
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import { Field, DropdownField } from '@samc/centricity-core';
  import { DealSource } from '@/Sources';
  import { IDeal } from '@/Interfaces';

  @Component({
    name: 'deal-dropdown-field',
    components: { Field, DropdownField }
  })
  export default class DealDropdownField extends Vue {
    @Prop() public value!: string;
    @Prop({ default: 'Deal' }) public label!: string;
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;
    @Prop({ type: Boolean, default: false }) public autoAssign!: boolean;
    @Prop() public placeholder!: string;
    @Prop({ default: '' }) public errorText!: string;
    @Prop({ default: [] }) public loanIds!: number[];
    @Prop({ default: null }) public deals!: IDeal[] | null;

    public source: IDeal[] | DealSource | null = null;

    public get val(): string { return this.value; }
    public set val(value: string) {
      this.$emit('input', value);
    }

    public created() {
      this.source = this.deals ?? new DealSource(this.loanIds);
    }
  }
